import { createContextStore } from "@faire/web/ui/hooks/ContextStore";

export type ChatBubbleStore = {
  customBottomSpacing?: string;
  tabTitle?: string;
  disableHideOnScroll?: boolean;
  isShowingChat?: boolean;
  openChat?: (params?: {
    brandToken?: string;
    retailerToken?: string;
    otherPartyUserToken?: string;
    conversationToken?: string;
  }) => void;
  closeChat?: () => void;
};

const { useStore: useChatBubbleStore, Provider: ChatBubbleStoreProvider } =
  createContextStore<ChatBubbleStore>({}, { name: "ChatBubbleStore" });

export { useChatBubbleStore, ChatBubbleStoreProvider };
